import React from "react";
import { Link } from "react-router-dom";
import { BackButton } from "../../components/BackButton";

const Art = ({ n, title, children }) => (
  <section>
    <h2 className="font-display font-bold text-xl mb-2">{n}. {title}</h2>
    <div className="space-y-2">{children}</div>
  </section>
);

export default function Intermediation() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12" data-testid="page-intermediation">
      <BackButton to="/" label="Retour" />
      <div className="overline text-accent">— Annexe G</div>
      <h1 className="font-display font-bold text-4xl tracking-tighter mb-2">Clauses d'intermédiation MML</h1>
      <p className="text-sm text-neutral-500 font-mono mb-4">Relation entre MML (plateforme) et les utilisateurs (expéditeurs et entreprises).</p>
      <div className="mb-8 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
        <b>Projet à valider par un avocat.</b> Document indicatif pour préparer la rédaction définitive.
      </div>

      <div className="space-y-6 text-[15px] leading-relaxed">
        <Art n="1" title="Service et indépendance des entreprises">
          <p>MML fournit un <b>service de mise en relation</b> entre expéditeurs et entreprises de transport indépendantes. MML n'est ni transporteur, ni commissionnaire de plein exercice au sens d'une prise en charge des biens : le <Link to="/legal/contrat-transport" className="text-[#1F4032] underline">contrat de transport</Link> est conclu directement entre l'expéditeur et l'entreprise, qui restent seuls responsables de son exécution.</p>
        </Art>
        <Art n="2" title="Tarif et rémunération de la plateforme">
          <p>La grille tarifaire (Annexe C) est <b>indicative</b> : l'expéditeur fixe librement son prix. MML perçoit une <b>commission de 15 % TTC</b> du prix total ; le transporteur perçoit <b>85 %</b>. Les <b>frais de paiement sont supportés par MML</b>. Le régime de TVA de chaque partie est paramétré ; un client professionnel peut voir un coût HT différent selon le candidat, affiché avant son choix.</p>
        </Art>
        <Art n="3" title="Classement et visibilité">
          <p>Les candidats sont classés principalement selon la <b>note issue de missions réelles</b> (nombre et récence des avis visibles), la rapidité de réponse étant un critère secondaire mesuré sur les seules périodes de disponibilité déclarées. Le classement ne masque pas les autres candidats. Toute mise en avant payante éventuelle serait signalée. Les critères sont publiés.</p>
        </Art>
        <Art n="4" title="Documents, modifications et assistance">
          <p>Les entreprises fournissent et maintiennent à jour leurs pièces (immatriculation, licence transport, assurances, permis, carte grise, contrôle technique). Les <b>nouvelles missions sont bloquées si une pièce a expiré</b>. Assistance MML : <b>du lundi au vendredi, 9h30–19h30 (Europe/Paris)</b> ; le site reste accessible 24/7 et les demandes hors horaires sont enregistrées et traitées à la reprise.</p>
        </Art>
        <Art n="5" title="Mesures de compte et recours">
          <p>MML peut prendre des mesures proportionnées (suspension conservatoire, demande d'observations) selon une procédure motivée, avec <b>recours humain</b>. Les situations d'entreprise et de chauffeur sont distinguées. Une impossibilité légitime ou un cas de force majeure ne vaut pas automatiquement faute.</p>
        </Art>
      </div>
    </div>
  );
}
